import React from 'react';
import { ReactComponent as Selected } from './selected.svg';
import './Feedback.scss';
import { getPlanSubscribe } from '../@helper/common/common';

const GET_TEXT = [
    'History of your family members\' whereabouts for up to 2 weeks',
    'Driver Protection to alert you about distracted driving, or in case of an accident',
    'Unlimited number of location alerts to know when they come or go',
    'Cancel any time. 30-day money-back guarantee',
];

const COMMENT_TEXT = [
    {
        text: 'Great app. Great way to keep tabs on the kids',
        name: 'Dini2776',
    },
    {
        text: `I highly recommend! I haven't found a better one. No need. This is the best.`,
        name: 'Huo_1212',
    },
    {
        text: `Love it... Works beautifully, and I keep tracking my family and friends...Best app ever... Thank youuuuu...And the best part of all... It's FREEE`,
        name: 'Ann Taylor',
    },
];

const renderComment = (item) => (
    <div className="feedback__comments-item" key={item.name}>
        <p className="feedback__comments-text">{item.text}</p>
        <div className="feedback__comments-footer">
            <p className="feedback__comments-name"><b>{item.name}</b></p>
            <img alt="icon" className="feedback__comments-icon" src="/images/app.png" />
        </div>
    </div>
);

const renderText = (item, index) => (<div key={index} className="feedback__item"><Selected /><p className="feedback__item__text" dangerouslySetInnerHTML={{ __html: item }} /></div>);

const Feedback = () => {
    const { footer } = getPlanSubscribe();
    return (
        <div className="container container__center">
            <div className="feedback">
                <h3 className="feedback__title">What you get</h3>
                <div className="feedback__list">
                    {
                        GET_TEXT.map(renderText)
                    }
                </div>
                <div className="feedback__center">
                    <h3 className="feedback__title">Millions of families trust us</h3>
                    <p className="feedback__stars__text">Over 30,000+ 5-star reviews</p>
                    <div className="feedback__stars">
                        <img alt="icon" src="/images/stars.png" />
                    </div>
                    <div className="feedback__comments">
                        {
                            COMMENT_TEXT.map(renderComment)
                        }
                    </div>
                </div>
                <p className="feedback__desc">
                    {
                        footer
                    }
                </p>
            </div>
        </div >
    )
};

export default Feedback;